module.exports = __webpack_public_path__ + "img/zh_hk.b8c75e82.png";